define('ordersController',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'ordersMailsUtils',
  'ordersMollieUtils',
  'ordersOrderUtils',
  'modalsConfirmationView',
  'ordersAlertView',
  'ordersConfirmationView',
  'modalView',
  'ordersPaymentLinkModalView',
  'ordersHistoryView',
  'ordersLabelsEditView',
  'ordersDuplicateView',
  'changeDatePopupView',
  'userSelectorView',
  'entities/customers/customers',
  'entities/orders',
  'entities/mails'
], function (
  App,
  module,
  Backbone,
  _,
  Settings,
  OrdersMailsUtils,
  OrdersMollieUtils,
  OrderUtils,
  ConfirmationView,
  OrdersAlertView,
  OrdersConfirmationView,
  ModalView,
  OrdersPaymentLinkModalView,
  HistoryView,
  LabelsEditView,
  DuplicateView,
  ChangeDatePopupView,
  UserSelectorView
) {
  'use strict';

  module.exports = {
    archive: function (models) {
      if(models.length > 0) {
        var title = _.i18n('orders.archive.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.archive.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
          title,
            models,
          _.bind(function () {
            _.each(models, _.bind(function (model) {
              model.archive().done(_.bind(function () {
                model.fetch();
              }, this)).fail(_.bind(function () {
                OrdersAlertView.prototype.open(_.i18n('orders.archive.alert.modal.text'), '', model);
              }, this));
            }, this));
          }, this)
        );
      }
    },

    unarchive: function (models) {
      if(models.length > 0) {
        var title = _.i18n('orders.unarchive.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.unarchive.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
          title,
          models,
          _.bind(function () {
            _.each(models, _.bind(function (model) {
              model.unarchive().done(_.bind(function () {
                model.fetch();
              }, this)).fail(_.bind(function () {
                OrdersAlertView.prototype.open(_.i18n('orders.unarchive.alert.modal.text'), '', model);
              }, this));
            }, this));
          }, this)
        );
      }
    },

    deleteOrders: function (models, removed) {
      if (models.length > 0) {
        var title = _.i18n('orders.delete.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.delete.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
            title,
            models,
            _.bind(function () {
              _.each(models, _.bind(function (model) {
                model.remove().done(_.bind(function () {
                    if (removed)
                      removed(model);
                }, this)).fail(_.bind(function () {
                  OrdersAlertView.prototype.open(_.i18n('orders.delete.alert.modal.text'), '', model);
                }, this));
              }, this));
            }, this)
        );
      }
    },

    validate: function (models) {
      if(models.length > 0) {
        var title = _.i18n('orders.validate.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.validate.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
            title,
            models,
            _.bind(function () {
              _.each(models, _.bind(function (model) {
                model.validate().done(_.bind(function () {
                  model.fetch();
                }, this)).fail(_.bind(function () {
                  OrdersAlertView.prototype.open(_.i18n('orders.validate.alert.modal.text'), '', model);
                }, this));
              }, this));
            }, this)
        );
      }
    },

    invalidate: function (models) {
      if(models.length > 0) {
        var title = _.i18n('orders.invalidate.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.invalidate.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
            title,
            models,
            _.bind(function () {
              _.each(models, _.bind(function (model) {
                model.invalidate().done(_.bind(function () {
                  model.fetch();
                }, this)).fail(_.bind(function () {
                  OrdersAlertView.prototype.open(_.i18n('orders.invalidate.alert.modal.text'), '', model);
                }, this));
              }, this));
            }, this)
        );
      }
    },

    pimToCompuzz: function (models) {
      if(models.length > 0) {
        var title = _.i18n('orders.pimToCompuzz.confirmation.modal.text');
        if (models.length > 1)
          title = _.i18n('orders.pimToCompuzz.confirmation.modal.text.plural');

        OrdersConfirmationView.prototype.open(
            title,
            models,
            _.bind(function () {
              _.each(models, _.bind(function (model) {
                model.convertPimToCompuzz().done(_.bind(function () {
                  model.fetch();
                }, this)).fail(_.bind(function (e) {
                  var message = '';
                  if(e.responseText)
                    message = e.responseText;
                  OrdersAlertView.prototype.open(_.i18n('orders.pimToCompuzz.alert.modal.text'), message, model);
                }, this));
              }, this));
            }, this)
        );
      }
    },

    copyToClipboard: function (value) {
      var $temp = $('<textarea>');
      var brRegex = /<br\s*[\/]?>/gi;
      $('body').append($temp);
      $temp.val(value.replace(brRegex, '\r\n').trim()).select();
      document.execCommand('copy');
      $temp.remove();
    },

    contextMenu: function(type, orders, lastSelected, callback) {
      var menu = {};      

      //------------------
      if(orders.length === 1) {
        var order = orders[0];
        menu.poi = {
          name: order.get('purchaseOrderId'),
          callback: _.bind(function () {
            this.copyToClipboard(order.get('purchaseOrderId'));
            callback();
          }, this)
        };
        menu.poiSep = '---------';
      }

      //------------------
      if(orders.length === 1) {
        var value = lastSelected.get('endUserId');
        if(lastSelected.get('customer') && lastSelected.get('customer').email)
          value = lastSelected.get('customer').email;

        var emails = value.split(';');
        _.each(emails, function (email, index) {
          if(index < 3) {
            menu['copyMail_' + index] = {
              name: email,
              callback: _.bind(function () {
                this.copyToClipboard(email);
                callback();
              }, this)
            };
          }
        }, this);
        menu.copyMailSep = '---------';
      }

      //------------------
      menu.filterCustomer = {
        name: _.i18n('common.filterby').replace('%s', lastSelected.get('endUserId')),
        callback: _.bind(function () {
          if(lastSelected.get('endUserId'))
            this.filtersView.onConfirm(new Backbone.Model({
              endUserId: lastSelected.get('endUserId')
            }));
          callback();
        }, this)
      };
      menu.filterCustomerSep = '---------';

      //------------------
      var mailsSubMenu = [];
      mailsSubMenu.push({
        name: _.i18n('mails.new'),
        callback: _.bind(function () {
          OrdersMailsUtils.sendMail(orders);
          callback();   
        }, this)
      });

      _.each(Settings.configValue('mails.templates'), function (template) {
        if(template.contextMenu === true) {
          mailsSubMenu.push({
            name: _.i18n('mails.template.' + template.template),
            callback: _.bind(function () {              
              OrdersMailsUtils.sendMail(orders, template, null, {orderByEmail: true});
              callback();
            }, this)
          });
        }
      }, this);

      menu.mail = {
        name: _.i18n('common.email'),
        items: mailsSubMenu      
      };
      menu.mailSep = '---------';

      //------------------

      var showCancel = false;
      _.each(orders, function (order) {
        if (order.get('status') !== 'CANCELLED')
          showCancel = true;
      });

      if(showCancel) {
        menu.cancel = {
          name: _.i18n('common.cancel'),
          callback: _.bind(function () {
            _.each(orders, function (order) {
              if (order.get('status') !== 'CANCELLED') {
                order.updateStatus('CANCELLED').done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);

            callback();
          }, this)
        };
        menu.cancelSep = '---------';
      }

      //------------------
      var showDecline = false;
      _.each(orders, function (order) {
        if (order.get('status') !== 'DECLINED')
          showDecline = true;
      });

      if(showDecline) {
        menu.decline = {
          name: _.i18n('common.declined'),
          callback: _.bind(function() {
            _.each(orders, function (order) {
              if(order.get('status') !== 'DECLINED') {
                order.updateStatus('DECLINED').done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
        menu.declineSep = '---------';
      }

      //------------------
      if(orders.length === 1) {
        menu.duplicacte = {
          name: _.i18n('common.duplicate'),
          callback: _.bind(function() {
            var order = orders[0];
            DuplicateView.prototype.open(
              order
            );
            callback();
          }, this)
        };
        menu.duplicateSep = '---------';
      }

      //------------------
      menu.history = {
        name: _.i18n('common.history'),
        callback: _.bind(function() {
          _.each(orders, function (order) {
            HistoryView.prototype.open(order);
          }, this);
          callback();
        }, this)
      };
      menu.historySep = '---------';

      //------------------
      var showPayedByCustomer = false;
      _.each(orders, function (order) {
        if (order.get('payedByCustomer') !== true)
          showPayedByCustomer = true;
      });

      if(showPayedByCustomer) {
        menu.payedByCustomer = {
          name: _.i18n('offerList.payedByCustomer'),
          callback: _.bind(function() {
            _.each(orders, function (order) {
              if(order.get('payedByCustomer') !== true) {
                order.updateCustomerPayment(true).done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
      }

      //------------------
      var showUnPayedByCustomer = false;
      _.each(orders, function (order) {
        if (order.get('payedByCustomer') !== false)
          showUnPayedByCustomer = true;
      });

      var ordersToUnpay = [];
      _.each(orders, function (order) {
        if (order.get('payedByCustomer') !== false)
          ordersToUnpay.push(order);
      }, this);

      if(showUnPayedByCustomer) {
        menu.unPayedByCustomer = {
          name: _.i18n('offerList.UnPayedByCustomer'),
          callback: _.bind(function() {
            OrdersConfirmationView.prototype.open(
              _.i18n('orders.unpay.confirmation.modal.text'),
              ordersToUnpay,
              _.bind(function () {
                _.each(ordersToUnpay, function (order) {
                  order.updateCustomerPayment(false).done(_.bind(function () {
                    order.fetch();
                  }, this));
                }, this);
              }, this)
            );

            callback();
          }, this)
        };
      }
      if(showPayedByCustomer || showUnPayedByCustomer)
        menu.payedByCustomerSep = '---------';

      //------------------
      menu.proFormat = {
        name: _.i18n('offerList.proforma'),
        callback: _.bind(function() {
          var pois = [];
          _.each(orders, function (order) {
            pois.push(order.get('purchaseOrderId'));
          }, this);
          if(lastSelected) {
            this.customer = App.request('customers:entity:end-user-id', lastSelected.get('endUserId'));

            this.customer.fetch().done(_.bind(function () {
              if(this.customer.get('vatNumber') && this.customer.get('vatNumber') !== '') {
                if (this.customer.get('vatNumberChecked') === true) {
                  if (this.customer.get('vatNumberValid') === false) {
                    ConfirmationView.prototype.open({
                      text: _.i18n('orders.vat.not-valid'),
                      onConfirm: _.bind(function () {
                        window.location = Settings.url('dl', 'proforma', {
                          pois: pois.join(','),
                          v: Settings.configValue('advancedMode')?'2':'1'
                        });
                      }, this)
                    });
                  } else {
                    window.location = Settings.url('dl', 'proforma', {
                      pois: pois.join(','),
                      v: Settings.configValue('advancedMode')?'2':'1'
                    });
                  }
                } else {
                  this.customer.checkVat().done(_.bind(function (valid) {
                    if (!valid) {
                      ConfirmationView.prototype.open({
                        text: _.i18n('vat.not-valid'),
                        onConfirm: _.bind(function () {
                          window.location = Settings.url('dl', 'proforma', {
                            pois: pois.join(','),
                            v: Settings.configValue('advancedMode')?'2':'1'
                          });
                        }, this)
                      });
                    } else {
                      window.location = Settings.url('dl', 'proforma', {
                        pois: pois.join(','),
                        v: Settings.configValue('advancedMode')?'2':'1'
                      });
                    }
                  }, this)).fail(_.bind(function () {
                    ConfirmationView.prototype.open({
                      text: _.i18n('vat.checkVatError'),
                      onConfirm: _.bind(function () {
                        window.location = Settings.url('dl', 'proforma', {
                          pois: pois.join(','),
                          v: Settings.configValue('advancedMode')?'2':'1'
                        });
                      }, this)
                    });
                  }, this));
                }
              } else {
                ConfirmationView.prototype.open({
                  text: _.i18n('vat.empty-vat'),
                  onConfirm: _.bind(function () {
                    window.location = Settings.url('dl', 'proforma', {
                      pois: pois.join(','),
                      v: Settings.configValue('advancedMode')?'2':'1'
                    });
                  }, this)
                });
              }
            }, this));
          }

          callback();
        }, this)
      };
      menu.proFormatSep = '---------';

      //------------------
      var showFlag = false;
      _.each(orders, function (order) {
        if (order.get('flag') !== 'E')
          showFlag = true;
      });

      if(showFlag) {
        menu.flag = {
          name: _.i18n('offerList.flag'),
          callback: _.bind(function() {
            _.each(orders, function (order) {
              if(order.get('flag') !== 'E') {
                order.updateFlag('E').done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
        menu.flagSep = '---------';
      }

      //------------------
      var showUnFlag = false;
      _.each(orders, function (order) {
        if (order.get('flag') === 'E')
          showUnFlag = true;
      });

      if(showUnFlag) {
        menu.unflag = {
          name: _.i18n('offerList.unflag'),
          callback: _.bind(function() {
            _.each(orders, function (order) {
              if(order.get('flag') === 'E') {
                order.updateFlag('').done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
        menu.unflagSep = '---------';
      }

      //------------------
      var showPrio0 = false;
      _.each(orders, function (order) {
        if (order.get('priority') !== 0)
          showPrio0 = true;
      });

      if(showPrio0) {
        menu.prio0 = {
          name: _.i18n('offerList.prio0'),
          callback: _.bind(function () {
            _.each(orders, function (order) {
              if (order.get('priority') !== 0) {
                order.updatePriority(0).done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
      }

      //------------------
      var showPrio1 = false;
      _.each(orders, function (order) {
        if (order.get('priority') !== 1)
          showPrio1 = true;
      });

      if(showPrio1) {
        menu.prio1 = {
          name: _.i18n('offerList.prio1'),
          callback: _.bind(function () {
            _.each(orders, function (order) {
              if (order.get('priority') !== 1) {
                order.updatePriority(1).done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
      }

      //------------------
      var showPrio2 = false;
      _.each(orders, function (order) {
        if (order.get('priority') !== 2)
          showPrio2 = true;
      });

      if(showPrio2) {
        menu.prio2 = {
          name: _.i18n('offerList.prio2'),
          callback: _.bind(function () {
            _.each(orders, function (order) {
              if (order.get('priority') !== 2) {
                order.updatePriority(2).done(_.bind(function () {
                  order.fetch();
                }, this));
              }
            }, this);
            callback();
          }, this)
        };
      }
      menu.prioSep = '---------';

      //------------------
      menu.toInvoice = {
        name: _.i18n('offerList.toInvoice'),
        callback: _.bind(function() {
          if(lastSelected.get('endUserId'))
            OrdersMailsUtils.createSendInvoiceMail(orders, lastSelected.get('endUserId')).done(_.bind(function () {
              _.each(orders, function (order) {
                order.trigger('invoices:new');
              }, this);
            }, this));
          callback();
        }, this)
      };
      menu.toInvoiceSep = '---------';

      //------------------
      if (Settings.configValue('advancedMode') === true) {
        menu.paymentLink = {
          name: _.i18n('common.molliePaymentLink'),
          callback: _.bind(function() {
            OrdersMollieUtils.getMolliePaymentLinkTotal(orders).done(_.bind(function (total) {            
              var model = new Backbone.Model({
                total: total
              });
              ModalView.prototype.open({
                childView: OrdersPaymentLinkModalView,
                model: model,
                orders: orders,
                confirmButtonText: _.i18n('order.payment-link-modal.confirm-button-text'),
                title: _.i18n('common.molliePaymentLink'),
                onConfirm: _.bind(function (model) {
                  OrdersMollieUtils.createMolliePaymentLinkMail(orders, model.get('total'))
                  .done(_.bind(function () {
                    var pois = [];
                    _.each(orders, function (order) {
                      pois.push(order.get('purchaseOrderId'));
                      order.trigger('paymentLink:new');
                    }, this);

                    var url = '';
                    if (orders.length > 1)
                      url = '/#orders/' + orders[0].get('purchaseOrderId') + '/mollie';

                    var template = '<div data-notify="container" class="custom-notify" role="alert">';
                    template += '<span data-notify="title" class="title">{1}</span>';
                    template += '<span data-notify="message" class="text">{2}</span>';
                    template += '</div>';

                    $.notify({
                      // Options du message
                      title: '<strong>' + _.i18n('order.payment-link-notidy.title') + '</strong><br>',
                      message: _.i18n('order.payment-link-notidy.text').replace('%s', pois.join(', ')).replace('%s', url)
                    }, {
                      type: 'success', // ou 'danger', 'info', 'warning'
                      placement: {
                        from: 'top',
                        align: 'right'
                      },
                      delay: 5000,
                      animate: {
                        enter: 'animated fadeInDown',
                        exit: 'animated fadeOutUp'
                      },
                      template: template
                    });
                  }, this));

                  callback();
                }, this),
                onCancel: _.bind(function () {
                  callback();
                }, this)
              });
            }, this));
          }, this)
        };
        menu.paymentLinkSep = '---------';
      }

      //------------------
      menu.convert = {
        name: type === 'command' ? _.i18n('offerList.convertToOffer') : _.i18n('offerList.convertToOrder'),
        callback: _.bind(function() {
          _.each(orders, function (order) {
            var newType = type === 'command' ? 'offer' : 'command';
            order.updateType(newType).done(_.bind(function () {
              this.bodyView.collection.remove(order);
            }, this));
          }, this);
          callback();
        }, this)
      };
      menu.convertSep = '---------';

      //------------------
      menu.deliveryNote = {
        name: _.i18n('common.downloadDeliveryNote'),
        callback: _.bind(function() {
          var pois = [];
          _.each(orders, function (order) {
            pois.push(order.get('purchaseOrderId'));
          }, this);

          if(pois.length > 0) {
            var order = orders[0];

            var customer = App.request('customers:entity:end-user-id', order.get('endUserId'));
            customer.fetch().done(_.bind(function () {
              window.location = order.getDeliveryFileUrl(pois, customer);
            }, this));
          }
          callback();
        }, this)
      };
      menu.deliveryNoteSep = '---------';

      //------------------
      var statusesItems = {};
      App.request('orders:statuses', type).done(_.bind(function (statuses) {
        _.each(statuses.models, _.bind(function (status) {
          statusesItems[status.get('statusConst')] = {
            name: status.get('status'),
            callback: _.bind(function () {
              _.each(orders, function (order) {
                order.updateStatus(status.get('statusConst')).done(_.bind(function () {
                  order.fetch();
                }, this));
              }, this);

              //--------------------
              try {
                if(status.get('params')) {
                  var params = JSON.parse(status.get('params'));

                  OrdersMailsUtils.check(orders, params).done(_.bind(function () {
                    var template = null;
                    if(params.params && params.params.type)
                      template = params.params.type;

                    if(template) {
                      var configTemplate = null;
                      _.each(Settings.configValue('mails.templates'), function (t) {
                        if (t.template === template)
                          configTemplate = t;
                      }, this);
                      if (configTemplate)
                        OrdersMailsUtils.sendMail(orders, configTemplate);
                    }
                  }, this));
                }
              } catch (e) {
                console.log(e);
              }

              callback();
            }, this)
          };
        }, this));
      }, this));

      menu.statuses = {
        name: _.i18n('orderList.status'),
        items: statusesItems
      };
      menu.statusesSep = '---------';

      //------------------
      menu.colors = {
        name: _.i18n('orderList.color'),
        callback: _.bind(function () {
          if (orders.length > 0)
            LabelsEditView.prototype.open(orders);
          callback();
        }, this)
      };

      menu.colorsSep = '---------';

      //------------------     
      menu.proofsheet = {
        name: _.i18n('common.proofsheet'),
        callback: _.bind(function() {
          if(orders.length > 0) {
            var customer = App.request('customers:entity:end-user-id', orders[0].get('endUserId'));
            customer.fetch().done(_.bind(function () {      
              var proofsheetUrl = OrderUtils.getProofSheetUrl(orders[0], customer);
              if (proofsheetUrl)         
                window.open(proofsheetUrl, '_blank');   
            }, this));
          }
          callback();
        }, this)
      };
      menu.proofsheetSep = '---------';      

      //------------------
      menu.downloadProofsheet = {
        name: _.i18n('common.downloadProofsheet'),
        callback: _.bind(function() {
          _.each(orders, function (order) {
            var customer = App.request('customers:entity:end-user-id', order.get('endUserId'));
            customer.fetch().done(_.bind(function () {
              var fileName = order.getProofsheetFilename(customer);
              window.open(order.getProofsheetDownloadUrl(fileName, customer), '_blank');
            }, this));
          });
          callback();
        }, this)
      };
      menu.downloadProofsheetSep = '---------';

      //------------------
      var showArchive = false;
      _.each(orders, function (order) {
        if (order.get('archived') !== true)
          showArchive = true;
      });

      if(showArchive) {
        menu.archive = {
          name: _.i18n('common.archive'),
          callback: _.bind(function () {
            var models = [];
            _.each(orders, function (order) {
              if (order.get('archived') !== true)
                models.push(order);
            }, this);
            this.archive(models);
            callback();
          }, this)
        };
      }

      //------------------
      var showUnArchive = false;
      _.each(orders, function (order) {
        if (order.get('archived') !== false)
          showUnArchive = true;
      });

      if(showUnArchive) {
        menu.unarchive = {
          name: _.i18n('common.unarchive'),
          callback: _.bind(function () {
            var models = [];
            _.each(orders, function (order) {
              if (order.get('archived') !== false)
                models.push(order);
            }, this);
            this.unarchive(models);
            callback();
          }, this)
        };
      }
      menu.archiveSep = '---------';

      //------------------
      menu.deleteOrder = {
        name: _.i18n('common.delete'),
        callback: _.bind(function() {
          this.deleteOrders(orders, _.bind(function (order) {
            this.bodyView.collection.remove(order);
          }, this));
          callback();
        }, this)
      };
      menu.deleteSep = '---------';

      //------------------
      menu.assignUser = {
        name: _.i18n('common.assignTo'),
        callback: _.bind(function() {

          var userids = [];
          _.each(orders, function (order) {
            if(order.get('userpids')) {
              var ids = [];
              _.each(order.get('userpids'), function (userpid) {
                ids.push(userpid.secId);
              });

              userids = _.union(userids, ids);
            }
          }, this);

          _.each(orders, function (order) {
            if(order.get('userpids')) {
              var ids = [];
              _.each(order.get('userpids'), function (userpid) {
                ids.push(userpid.secId);
              });

              userids = _.intersection(userids, ids);
            }
          }, this);

          App.request('kanban-tickets:get-users').done(_.bind(function (users) {
            var userpids = [];
            _.each(users, _.bind(function (user) {
              if(_.contains(userids, user.secId))
                userpids.push(user);
            }, this));

            var usersCollection = new Backbone.Collection(userpids);

            UserSelectorView.prototype.open({
              users: usersCollection.models,
              multiselect: true,
              onSelected: _.bind(function (user) {
                var deferred = new $.Deferred();

                _.each(orders, function (order) {
                  order.assignUser(user.get('secId')).done(_.bind(function () {
                      order.fetch();
                  }, this));
                }, this);

                deferred.resolve();
                return deferred;
              }, this),
              onUnSelected: _.bind(function (user) {
                var deferred = new $.Deferred();

                _.each(orders, function (order) {
                  order.unassignUser(user.get('secId')).done(_.bind(function () {
                    order.fetch();
                  }, this));
                }, this);

                deferred.resolve();
                return deferred;
              }, this)
            });
            callback();
          }, this));

          callback();
        }, this)
      };
      menu.assignUserSep = '---------';

      //------------------
      var date = null;
      if (orders.length === 1)
        date = orders[0].get('deadlineDate');

      menu.deadlineDate = {
        name: _.i18n('order.deadlineDate'),
        callback: _.bind(function () {
          var popupView = new ChangeDatePopupView({
            date: date,
            label: _.i18n('order.deadlineDate'),
            offset: 0
          });
          popupView.show({
            title: _.i18n('order.deadlineDate'),
            className: 'vectorizationAddNew',
            buttons: {
              reset: {
                label: _.i18n('common.reset'),
                className: 'btn-default',
                callback: _.bind(function () {
                  _.each(orders, function (order) {
                    var obj = {
                      purchaseOrderId: order.get('purchaseOrderId'),
                      refCommand: {
                        updateProperties: true
                      },
                      deadlineDate: null
                    };

                    App.request('order:update', obj).done(_.bind(function () {
                      order.fetch();
                    }, this));
                  }, this);
                }, this)
              },
              cancel: {
                label: _.i18n('common.cancel'),
                className: 'btn-default',
                callback: function () {
                  return true;
                }
              },
              main: {
                label: _.i18n('common.save'),
                className: 'btn btn-primary',
                callback: _.bind(function () {
                  _.each(orders, function (order) {
                    var obj = {
                      purchaseOrderId: order.get('purchaseOrderId'),
                      refCommand: {
                        updateProperties: true
                      },
                      deadlineDate: popupView.options.date
                    };

                    App.request('order:update', obj).done(_.bind(function () {
                      order.fetch();
                    }, this));
                  }, this);
                }, this)
              }
            }
          });

        }, this)
      };
      menu.deadlineDateSep = '---------';

      //------------------
      if(Settings.configValue('orders.showValidationButton')) {
        var showValidate = false;
        _.each(orders, function (order) {
          if (order.get('validated') !== true)
            showValidate = true;
        });

        if(showValidate) {
          menu.validate = {
            name: _.i18n('common.validate'),
            callback: _.bind(function () {
              var models = [];
              _.each(orders, function (order) {
                if (order.get('validated') !== true)
                  models.push(order);
              }, this);
              this.validate(models);
              callback();
            }, this)
          };
        }

        //------------------
        var showUnValidate = false;
        _.each(orders, function (order) {
          if (order.get('validated') !== false)
            showUnValidate = true;
        });

        if(showUnValidate) {
          menu.unValidate = {
            name: _.i18n('common.unvalidate'),
            callback: _.bind(function () {
              var models = [];
              _.each(orders, function (order) {
                if (order.get('validated') === true)
                  models.push(order);
              }, this);
              this.invalidate(models);
              callback();
            }, this)
          };
        }
      }

      return menu;
    },    

    createAddress: function (data, cr) {
      var addressFormat = Settings.configValue('orders.addressFormat');

      if(data !==null){
        data.country = '';
        if(data.countryCode) {
          var country = _.findWhere(Settings.get('countries'), {code: data.countryCode});
          if(country)
            data.country = country.name;
        }
      }

      var address = '';
      _.each(addressFormat, function (item) {
        var line = item.format;
        _.each(item.fields, function (field) {
          if((data !==null) && data[field])
            line = line.replace('%' + field, data[field]);
          else
            line = line.replace('%' + field, '');
        }, this);
        if(line.trim() !== '') {
          if(address !== '')
            address += '%cr';
          address += line.trim();
        }
      }, this);

      address = address.replaceAll('%cr', cr).trim();

      return address;
    }
  };
});

